import { render, staticRenderFns } from "./informe-detail.vue?vue&type=template&id=87d153e8&scoped=true"
import script from "./informe-detail.vue?vue&type=script&lang=js"
export * from "./informe-detail.vue?vue&type=script&lang=js"
import style0 from "./informe-detail.vue?vue&type=style&index=0&id=87d153e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d153e8",
  null
  
)

export default component.exports